import React from 'react';

const TermsPrivacy = () => (
  <div>
    <p>Effective Date: November 14, 2017</p>
    <p>
      <strong>Introduction</strong>
    </p>
    <p>
      Thank you for visiting a website, mobile app or other online
      service(“Service”) that belongs to and is operated by Henkel Corporation
      or one of its subsidiary or affiliated companies (“Henkel”, “Us”, “We”,
      “Our”).
    </p>
    <p>
      These Terms of Use (“Terms”) affect your legal rights, responsibilities
      and obligations and govern your use of the Service, are legally binding,
      limit Henkel’s liability to you and require you to indemnify us and, in
      certain jurisdictions, to settle certain disputes through individual
      arbitration.
    </p>
    <p>
      By visiting or otherwise using the Service in any manner, you agree to the
      then posted Terms and any applicable Additional Terms (defined below), to
      be bound by them, and that you have read and understood them.  You also
      acknowledge, agree and consent to Our data practices as described in Our{' '}
      <a
        href="https://www.henkel-northamerica.com/privacy-statement-na"
        style={{ textDecoration: 'underline' }}
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Statement
      </a>.
    </p>
    <p>
      If you do not wish to be bound by these Terms and any Additional Terms, do
      not use the Service and uninstall Service downloads and applications.
    </p>
    <p>
      <strong>Additional Terms</strong>
    </p>
    <p>
      In some instances, additional or different terms, posted on the Service,
      apply to your use of certain parts of the Service (individually and
      collectively “Additional Terms”).  To the extent there is a conflict
      between these Terms and any Additional Terms, these Terms will control
      unless the Additional Terms expressly state otherwise.
    </p>
    <p>Updates to these Terms and Additional Terms</p>
    <p>
      We may prospectively change these Terms and Additional Terms by posting
      new or changed terms on the Service as more fully explained [Section 13].
    </p>
    <h2>Full Terms of Use</h2>
    <br />
    <ol style={{ paddingLeft: '16px' }}>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Ownership and Operation</strong>
        </p>
        <p>
          The Service and all of its content (“Content”), including all
          copyrights, patents, trademarks, service marks, trade names and all
          other intellectual property rights therein (“Intellectual Property”),
          are owned or controlled by Henkel, Our licensors, and certain other
          third parties.  All right, title, and interest in and to the Content
          and Intellectual Property available via the Service is the property of
          Henkel, Our licensors or certain other third parties, and is protected
          by U.S. and international copyright, trademark, trade dress, patent
          and/or other intellectual property and unfair competition rights and
          laws to the fullest extent possible.  Henkel owns the copyright in the
          selection, compilation, assembly, arrangement, and enhancement of the
          Content on the Service.  Henkel, in its sole discretion without
          advance notice or liability, may immediately suspend or terminate the
          availability of the Service and/or content (and any elements and
          features of them), in whole or in part, for any reason, in Henkel’s
          sole discretion, and without advance notice or liability.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Intended Geographic Scope</strong>
        </p>
        <p>
          The Service and its Content are controlled from within the United
          States of America and Canada. Access to the Service from territories
          where its Content is illegal is prohibited. Those who choose to access
          the Service from outside the United States and Canada are responsible
          for compliance with all local laws applicable to them with respect to
          the Content and operation of the Service. You are responsible for
          complying with all applicable trade regulations and laws both foreign
          and domestic.  Except as authorized by U.S. and Canadian law, you
          agree and warrant not to export or re-export the software to any
          county, or to any person, entity, or end-user subject to U.S. and/or
          Canadian export controls or sanctions.
        </p>
        <p>
          The brands / products shown on the Service are examples of the brands
          / products available from companies of Henkel worldwide. Henkel does
          not warrant that a brand / product shown is also available in your
          country.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Privacy</strong>
        </p>
        <p>
          By visiting or otherwise using the Service in any manner, you agree to
          the then posted{' '}
          <a
            href="https://www.henkel-northamerica.com/privacy-statement-na"
            style={{ textDecoration: 'underline' }}
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Statement
          </a> and consent to data practices as described therein.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Limited Permission to Access and Use the Service</strong>
        </p>
        <p>
          It is Henkel policy to enforce its Intellectual Property rights to the
          fullest extent of the law, including seeking criminal sanctions. Your
          right to use the Service and Content is subject to your strict
          compliance with these Terms and the Additional Terms. Your right to
          access and use the Service and the Intellectual Property shall
          automatically terminate upon any violations. These rights are
          non-exclusive, limited, and revocable by Us at any time in our sole
          discretion without advance notice or liability. As your right to
          access and use the Service and the content is personal to you, you may
          not assign nor transfer your right; any attempt to do so is void. You
          may, for your personal, non-commercial, lawful use only (collectively,
          the following are the “Henkel Licensed Elements”):
        </p>
        <ol type="A" style={{ paddingLeft: '16px' }}>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Display, view, use, and play the Content on a computer, mobile or
              other internet enabled or permitted device (“Device”) and/or print
              one copy of the Content (excluding source and object code in raw
              form or otherwise) as it is displayed to you;
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Stream the Content using any of the widgets and/or other digital
              streaming internet video players, if any, provided on the Service;
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Subject to any applicable Additional Terms, if the Service
              includes a “Send to Friend,” social media sharing or similar tool
              that allows you to initiate and send to one or more of your
              contacts a communication that includes content, or to post Our
              content to Third-Party Services or your own site or online
              service, and the tool is operational, use the tool to do so;
              provided, however, that you do not do so in any manner that
              violates applicable law or third-party rights or reflects
              negativity on Us, and only send to recipients you have permission
              to contact;
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              If the Service includes a “Download” link next to a piece of
              content (including, without limitation, an image, an icon, a
              wallpaper, a music track, a video, a trailer, an RSS feed), you
              may only download a single copy of such content to a single
              Device;
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Download, install and use one copy of any software, including
              apps, that We make available on or through the Service
              (“Software”) on your Device in machine-executable object code form
              only and make one additional copy for back-up purposes; provided,
              however, that you understand and agree that (i) by allowing you to
              download the Software, Henkel does not transfer title to the
              Software to you (i.e., you own the medium on which the Software is
              recorded, but the Software’s owner (which may be Henkel  and/or
              its third-party Software licensor) will retain full and complete
              title to such Software); (ii) you may not copy, modify, adapt,
              translate into any language, distribute, or create derivative
              works based on the Software, except as expressly authorized in
              these Terms or applicable Additional Terms, without the prior
              written consent of Henkel: (iii) you may not assign, rent, lease,
              or lend the Software to any person or entity and any attempt by
              you to sublicense, transfer, or assign the Software will be void
              and of no effect; and (iv) you may not decompile, disassemble,
              reverse engineer, or attempt to reconstruct, identify, or discover
              any source code, underlying ideas, underlying user interface
              techniques, or algorithms of the Software by any means whatsoever,
              except to the extent the foregoing restriction is prohibited by
              applicable law;
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              If made available to you, obtain a registered personal account
              (and/or related username and password) on the Service and interact
              with the Service in connection therewith;
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Link to the Service from a website or other online service, so
              long as: (a) the links only incorporate text, and do not use any
              Henkel names, logos, or images, (b) the links and the content on
              your website do not suggest any affiliation with Henkel or cause
              any other confusion, and (c) the links and the content on your
              website do not portray Henkel or its products or services in a
              false, misleading, derogatory, or otherwise offensive manner, and
              do not contain content that is unlawful, offensive, obscene, lewd,
              lascivious, filthy, violent, threatening, harassing, or abusive,
              or that violate any right of any third-party or are otherwise
              objectionable to Henkel. Henkel reserves the right to suspend or
              prohibit linking to the Service for any reason, in its sole
              discretion, without advance notice or any liability of any kind to
              you or any third-party, and;
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Use any other functionality expressly provided by Henkel on or
              through the Service for use by users, subject to these Terms
              (including, without limitation, functionality to create and/or
              post User-Generated Content (as defined below)) and any applicable
              Additional Terms. Any unauthorized use or abuse of these
              intellectual property or works is expressly prohibited and
              constitutes a violation of trademark law, copyright law, other
              intellectual property rights or unfair competition law.
            </p>
          </li>
        </ol>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Service and Content Restrictions</strong>
        </p>
        <ol type="A" style={{ paddingLeft: '16px' }}>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Service Use Restrictions. You agree that you will not: (i) use the
              Service for any political or commercial purpose (including,
              without limitation, for purposes of advertising, soliciting funds,
              collecting product prices, and selling products); (ii) use any
              meta tags or any other “hidden text” utilizing any Intellectual
              Property; (iii) engage in any activities through or in connection
              with the Service that seek to attempt to or do harm any
              individuals or entities or are unlawful, offensive, obscene, lewd,
              lascivious, filthy, violent, threatening, harassing, or abusive,
              or that violate any right of any third-party, or are otherwise
              objectionable to Henkel; (iv) decompile, disassemble, reverse
              engineer, or attempt to reconstruct, identify, or discover any
              source code, underlying ideas, underlying user interface
              techniques, or algorithms of the Service by any means whatsoever
              or modify any Service source or object code or any Software or
              other products, services, or processes accessible through any
              portion of the Service; (v) engage in any activity that interferes
              with a user’s access to the Service or the proper operation of the
              Service, or otherwise causes harm to the Service, Henkel, or other
              users of the Service; (vi) interfere with or circumvent any
              security feature (including any digital rights management
              mechanism, device or other content protection or access control
              measure) of the Service or any feature that restricts or enforces
              limitations on use of or access to the Service, the Content, or
              the UGC; (vii) harvest or otherwise collect or store any
              information (including personally identifiable information about
              other users of the Service, including email addresses, without the
              express consent of such users); (viii) attempt to gain
              unauthorized access to the Service, other computer systems or
              networks connected to the Service, through password mining or any
              other means; or (ix) otherwise violate these Terms or any
              applicable Additional Terms.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Content Use Restrictions. You also agree that, in using the
              Service, you: (i) will not monitor, gather, copy, or distribute
              the Content (except as may be a result of standard search engine
              activity or use of a standard browser) on the Service by using any
              robot, rover, “bot”, spider, scraper, crawler, spyware, engine,
              device, software, extraction tool, or any other automatic device,
              utility, or manual process of any kind; (ii) will not frame or
              utilize framing techniques to enclose any such content (including
              any images, text, or page layout); (iii) will keep intact all
              trademark, copyright, and other Intellectual Property and other
              notices contained in such content; (iv) will not use such content
              in a manner that suggests an unauthorized association with any of
              Our or Our licensors’ products, services, or brands; (v) will not
              make any modifications to such content (other than to the extent
              of your specifically permitted by Us, if applicable); (vi) will
              not copy, modify, reproduce, archive, sell, lease, rent, exchange,
              create derivative works from, publish by hard copy or electronic
              means, publicly perform, display, disseminate, distribute,
              broadcast, retransmit, circulate or transfer to any third-party or
              on any third-party application or website, or otherwise use or
              exploit such content in any way for any purpose except as
              specifically permitted by these Terms or any applicable Additional
              Terms or with the prior written consent of an officer of Henkel
              or, in the case of content from a licensor, the owner of the
              content; and (vii) will not insert any code or product to
              manipulate such content in any way that adversely affects any user
              experience or the Service.
            </p>
          </li>
        </ol>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>User-Generated Content</strong>
        </p>
        <ol type="A" style={{ paddingLeft: '16px' }}>
          <li style={{ marginBottom: '16px' }}>
            <p>
              General. Henkel may now, or in the future, offer users of the
              Service the opportunity to create, build, post, upload, display,
              publish, distribute, transmit, broadcast, or otherwise make
              available on or submit through the Service, or on or in response
              to Our pages or posts on any third-party platforms or in
              connection with any of Our promotions by any media or manner, or
              otherwise submit to Us (e.g., on Our Facebook or other social
              media pages, in response to Our tweets, through a sweepstakes or
              contest, or by otherwise sending it to Us)
              (collectively, “submit”) messages, text, illustrations, files,
              images, graphics, photos, comments, responses, sounds, music,
              videos, information, content, ratings, reviews, data, questions,
              suggestions, personally identifiable information, or other
              information or materials and the ideas contained therein
              (collectively, but excluding Henkel Licensed Elements included
              therein, “User-Generated Content” or “UGC”).  You may submit UGC
              through your profile, forums, blogs, message boards, social
              networking environments, content creation and posting tools,
              gameplay, social communities, contact Us tools, email, and other
              communications functionality.  Except to the extent of the rights
              and license you grant in these Terms and, subject to any
              applicable Additional Terms, you retain whatever legally
              cognizable right, title, and interest that you have in your UGC.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Non-Confidentiality of Your User-Generated Content. Except as
              otherwise described in the Service’s posted <a
                href="https://www.henkel-northamerica.com/privacy-statement-na"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Statement
              </a>, or any applicable Additional Terms, you agree that (a) your
              UGC will be treated as non-confidential and non-proprietary by Us
              – regardless of whether you mark them “confidential,”
              “proprietary,” or the like – and will not be returned, and (b) to
              the maximum extent not prohibited by applicable law, Henkel does
              not assume any obligation of any kind to you or any third-party
              with respect to your UGC.  Upon request, you will provide
              documentation necessary to authenticate rights to such content and
              verify your compliance with these Terms or any applicable
              Additional Terms. You acknowledge that the Internet and{' '}
              <strong>!Syntax Error, ^</strong>mobile communications may be
              insecure and subject to breaches of security; according, you
              acknowledge and agree that your UGC is submitted at your own risk.
            </p>
            <p>
              In your communications with Henkel, please keep in mind that We do
              not seek any unsolicited ideas or materials for products or
              services, or even suggested improvements to products or services,
              including, without limitation, ideas, concepts, inventions, or
              designs for music, websites, apps, books, scripts, screenplays,
              motion pictures, television shows, theatrical productions,
              software or otherwise (collectively, “Unsolicited Ideas and
              Materials”).  Any Unsolicited Ideas and Materials you submit are
              deemed UGC and licensed to Us as set forth below.  In addition,
              Henkel retains all of the rights held by members of the general
              public with regard to your Unsolicited Ideas and Materials.
              Henkel’s receipt of your Unsolicited Ideas and Materials is not an
              admission by Henkel of their novelty, priority, or originality,
              and it does not impair Henkel’s right to contest existing or
              future intellectual property rights relating to your Unsolicited
              Ideas and Materials.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              License to Henkel of Your UGC. Except as otherwise described in
              any applicable Additional Terms (such as a promotion’s official
              rules), which specifically govern the submission of your UGC, or
              in Our{' '}
              <a
                href="https://www.henkel-northamerica.com/privacy-statement-na"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Statement
              </a>, you hereby grant Henkel the non-exclusive, unrestricted,
              unconditional, unlimited, worldwide, irrevocable, perpetual, and
              cost-free right and license to use, copy, record, distribute,
              reproduce, disclose, sell, re-sell, sublicense (through multiple
              levels), display, publicly perform, transmit, publish, broadcast,
              translate, make derivative works of, and otherwise use and exploit
              in any manner whatsoever, all or any portion of your UGC (and
              derivative works thereof), for any purpose whatsoever in all
              formats, on or through any means or medium now known or hereafter
              developed, and with any technology or devices now known or
              hereafter developed, and to advertise, market, and promote the
              same.  Without limitation, the granted rights include the right
              to: (a) configure, host, index, cache, archive, store, digitize,
              compress, optimize, modify, reformat, edit, adapt, publish in
              searchable format, and remove such UGC and combine same with other
              materials, and (b) use any ideas, concepts, know-how, or
              techniques contained in any UGC for any purposes whatsoever,
              including developing, producing, and marketing products and/or
              services.  You understand that in exercising such rights metadata,
              notices and content may be removed or altered, including copyright
              management information, and you consent thereto and represent and
              warrant you have all necessary authority to do so.  In order to
              further effect the rights and license that you grant to Henkel to
              your UGC, you also, as permitted by applicable law, hereby grant
              to Henkel and agree to grant to Henkel the unconditional,
              perpetual, irrevocable right to use and exploit your name,
              persona, and likeness in connection with any UGC, without any
              obligation or remuneration to you. Except as prohibited by law,
              you hereby waive, and you agree to waive, any moral rights
              (including attribution, anonymity, and integrity) that you may
              have in any UGC, even if it is altered or changed in a manner not
              agreeable to you.  To the extent not waivable, you irrevocably
              agree not to exercise such rights (if any) in a manner that
              interferes with any exercise of the granted rights.  You
              understand that you will not receive any fees, sums,
              consideration, or remuneration for any of the rights granted in
              this Section 6(c).
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Henkel’s Exclusive Right to Manage Our Service. Henkel may, but
              will not have any obligation to, review, monitor, display, post,
              store, maintain, accept, or otherwise make use of, any of your
              UGC, and Henkel may, in its sole discretion, reject, delete, move,
              re-format, remove or refuse to post or otherwise make use of UGC
              without notice or any liability to you or any third-party in
              connection with Our operation of UGC venues in an appropriate
              manner.  Without limitation, We may do so to address content that
              comes to Our attention that We believe is offensive, obscene,
              lewd, lascivious, filthy, violent, harassing, threatening,
              abusive, illegal or otherwise objectionable or inappropriate, or
              to enforce the rights of third parties or these Terms or any
              applicable Additional Terms.  Such UGC submitted by you or others
              need not be maintained on the Service by Us for any period of
              time, and you will not have the right, once submitted, to access,
              archive, maintain, change, remove, or otherwise use such UGC on
              the Service or elsewhere, except that California minors have
              certain rights to have certain content about them that they have
              themselves posted on the Service prospectively removed from public
              display as provided for in the <a
                href="https://www.henkel-northamerica.com/privacy-statement-na"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Statement
              </a>.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Representations and Warranties Related to Your UGC. Each time you
              submit any UGC, you represent and warrant that you are at least
              the age of majority in the jurisdiction in which you reside and
              are the parent or legal guardian, or have all proper consents from
              the parent or legal guardian, of any minor who is depicted in or
              contributed to any UGC you submit, and that, as to that UGC, (a)
              you are the sole author and owner of the intellectual property and
              other rights to the UGC, or you have a lawful right to submit the
              UGC and grant Henkel the rights to it that you are granting by
              these Terms and any applicable Additional Terms, all without any
              Henkel obligation to obtain consent of any third-party and without
              creating any obligation or liability of Henkel (b) the UGC is
              accurate; (c) the UGC does not and, as to Henkel’s permitted uses
              and exploitation set forth in these Terms, will not, infringe any
              intellectual property or other right of any third-party or any
              applicable law or regulation; and (d) the UGC will not violate
              these Terms or any applicable Additional Terms, or cause injury or
              harm to any person.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Enforcement.  Henkel has no obligation to monitor or enforce your
              Intellectual Property rights to your UGC, but you grant Us the
              right to protect and enforce Our rights to your UGC, including
              initiating actions in your name and on your behalf (at Henkel’s
              cost and expense, to which you hereby consent and irrevocably
              appoint Henkel as your attorney-in-fact, with the power of
              substitution and delegation, which appointment is coupled with an
              interest).
            </p>
          </li>
        </ol>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>DMCA Copyright Policy and Copyright Agent</strong>
        </p>
        <p>
          Henkel respects the Intellectual Property rights of others and expects
          users of its Service to do the same.  Henkel may remove content that
          in its sole discretion appears to infringe the Intellectual Property
          rights of others.  In addition, Henkel, in its sole and absolute
          discretion, may terminate the accounts of users who infringe the
          Intellectual Property rights of others.
        </p>
        <p>
          If you believe that a user of the Service has infringed your copyright
          rights, please notify Henkel’s Copyright Agent (contact information
          below) and provide the following information: (a) a physical or
          electronic signature of the person authorized to act on behalf of the
          owner of the copyright right; (b) an identification of the copyright
          protected property claimed to have been infringed; (c) a detailed
          description of the material that you claim is infringing, so that We
          may locate it, including the URL where the infringing material
          appears; (d) your address, telephone number, and email address; (e) a
          statement by you that you have a good faith belief that the allegedly
          infringing use is not authorized by the copyright owner, its agent, or
          the law; and (f) a statement by you, made under penalty of perjury,
          that the foregoing information is accurate and that you are authorized
          to act on behalf of the owner of the copyright(s) involved.
        </p>
        <p>
          Copyright Agent
          <br />
          Henkel Corporation
          <br />
          One Henkel Way
          <br />
          Rocky Hill, CT 06067
          <br />
          860/571-2661
          <br />
          <a
            href="mailto:CopyrightAgent@henkel.com"
            style={{ textDecoration: 'underline' }}
          >
            CopyrightAgent@henkel.com
          </a>
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Links and Third-Party Services</strong>
        </p>
        <p>
          We are not responsible for third parties or their content,
          advertisement(s), apps or sites (“Third-Party Services”).  For
          instance, portions of the Service may be integrated into or linked to
          third-party sites, platforms and apps that We do not control.
          Similarly, We may make ads and third-party content or services, which
          We also may not control, available to you on or via Our Service.  This
          may include the ability to register or sign in to Our Services using
          Facebook Connect or other third-party tools, and to post content on
          third-party sites and services using their plug-ins made available on
          Our Services.  Use caution when dealing with third parties and consult
          their terms of use and privacy policies.  We take no responsibility
          for Third-Party Services. In addition, while Henkel may provide you
          with a link to a third party web site, it is understood that Henkel
          does not endorse, approve, sponsor or support such sites.
        </p>
        <p>
          If you are accessing or using the Service through Apple, Android, or
          any other platform, these are Third-Party Services.  If you access Our
          Apps via Apple, click <a
            href="https://www.henkel-northamerica.com/new-content-item/802450"
            style={{ textDecoration: 'underline' }}
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a> for Additional Terms and conditions that are applicable to you
          and are incorporated into the Terms by this reference.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Disclaimer of Warranties</strong>
        </p>
        <p>
          We strive to accurately describe Our products or services offered on
          the Service; however, We do not warrant that such specifications,
          pricing, or other content on the Service is complete, accurate,
          reliable, current, or error-free and products may not be available in
          all areas.  For online orders, if available, Additional Terms apply.
        </p>
        <p>
          AS PERMITTED BY APPLICABLE LAW, THE MATERIALS AND INFORMATION ON THE
          SERVICE, AND ANY MATERIALS MADE AVAILABLE THROUGH THE SERVICE, ARE
          PROVIDED “AS IS”, “AS AVAILABLE”, AND “WITH ALL FAULTS” BASIS AND
          WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. TO THE
          FULLEST EXTENT PERMISSIBLE PURSUANT TO APPLICABLE LAW, HENKEL AND ITS
          DIRECT AND INDIRECT PARENTS, SUBSIDIARIES, AFFILIATES, AND EACH OF
          THEIR RESPECTIVE EMPLOYEES, DIRECTORS, MEMBERS, MANAGERS,
          SHAREHOLDERS, AGENTS, VENDORS, LICENSORS, LICENSEES, CONTRACTORS,
          CUSTOMERS, SUCCESSORS, AND ASSIGNS (COLLECTIVELY, “HENKEL PARTIES”)
          DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT
          LIMITED TO, ALL IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
          PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT.
        </p>
        <p>
          AS PERMITTED BY APPLICABLE LAW, HENKEL PARTIES DISCLAIM ALL LIABILITY
          AND ASSUME NO RESPONSIBILITY FOR THE RESULTS OF ANY DEFECTS OR
          INACCURACIES THAT MAY EXIST IN THE SERVICE OR FROM ITS OPERATION.
          HENKEL MAKES NO WARRANTY THAT (I) THE OPERATION OF THE SERVICE WILL
          MEET THE USER´S REQUIREMENTS; (II) ACCESS TO THE SERVICE WILL BE
          UNINTERRUPTED, TIMELY, SECURE, FREE OF VIRUSES, WORMS, TROJAN HORSES
          OR OTHER HARMFUL COMPONENTS, OR BE FREE OF DEFECTS OR ERRORS; (III)
          THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE SERVICE WILL BE
          ACCURATE OR RELIABLE; OR (IV) DEFECTS WILL BE CORRECTED. YOU (AND NOT
          HENKEL) ASSUME THE ENTIRE COST OF ALL SERVICING, REPAIR, OR CORRECTION
          THAT MAY BE NECESSARY FOR YOUR COMPUTER EQUIPMENT AND SOFTWARE AS A
          RESULT OF ANY VIRUSES, ERRORS OR ANY OTHER PROBLEMS WHATSOEVER YOU MAY
          HAVE AS A RESULT OF VISITING THE SERVICE.
        </p>
        <p>
          NOTWITHSTANDING THE FOREGOING, THIS SECTION DOES NOT EXPAND OR
          LIMIT (I) ANY EXPRESS, WRITTEN PRODUCT WARRANTY OR RELATED DISCLAIMERS
          THAT ARE PROVIDED BY HENKEL OR ITS SUPPLIERS WITH REGARD TO A PHYSICAL
          PRODUCT SOLD BY HENKEL, OR ANY WARRANTY ON A PHYSICAL PRODUCT TO THE
          EXTENT REQUIRED BY APPLICABLE LAW; (II) HENKEL PARTIES’ LIABILITY  FOR
          PERSONAL INJURY TO YOU CAUSED BY HENKEL PARTIES TO THE EXTENT NOT
          WAIVABLE OR CANNOT BE LIMITED UNDER APPLICABLE LAW; OR (III) ANY CAUSE
          OF ACTION YOU MAY HAVE AGAINST HENKEL PARTIES THAT IS NOT WAIVABLE OR
          CANNOT BE LIMITED UNDER APPLICABLE LAW.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Limitation of Liability</strong>
        </p>
        <p>
          AS PERMITTED BY APPLICABLE LAW, UNDER NO CIRCUMSTANCES, WHETHER DUE TO
          NEGLIGENCE OR OTHERWISE, SHALL HENKEL PARTIES BE LIABLE FOR ANY
          DAMAGES OR INJURY, INCLUDING ANY DIRECT, INDIRECT, SPECIAL,
          INCIDENTAL, CONSEQUENTIAL, PUNITIVE OR OTHER DAMAGES, INCLUDING BUT
          NOT LIMITED TO LOSS OF DATA OR PROFIT, THAT MAY RESULT FROM THE USE
          OF, OR THE INABILITY TO USE, THE SERVICE OR ANY MATERIALS IN THE
          SERVICE, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE
          OF THE SERVICE OR INFORMATION AVAILABLE IN THE SERVICE.  THESE
          INCLUDE, BUT ARE NOT LIMITED TO, DAMAGES OR INJURY CAUSED BY ERROR,
          OMISSION, INTERRUPTION, DEFECT, FAILURE OF PERFORMANCE, DELAY IN
          OPERATION OR TRANSMISSION, LINE FAILURE OR COMPUTER VIRUS, WORM,
          TROJAN HORSE OR OTHER HARMFUL COMPONENT. INCLUDING FOR INCIDENTAL OR
          CONSEQUENTIAL DAMAGES. AS PERMITTED BY APPLICABLE LAW, IN NO EVENT
          SHALL A HENKEL PARTIES’ TOTAL LIABILITY TO YOU FOR DAMAGES, LOSSES,
          AND/OR CAUSES OF ACTION ARISING OUT OF THE SERVICE EXCEED THE GREATER
          OF ONE HUNDRED DOLLARS ($100), OR THE AMOUNT YOU HAVE PAID HENKEL IN
          CONNECTION WITH A PRODUCT OR SERVICE UNDERLYING THE CLAIM, AND ANY
          CLAIM OR CAUSE OF ACTION YOU MAY HAVE WITH RESPECT TO THE
          SERVICE (INCLUDING BUT NOT LIMITED TO THE PURCHASE OF HENKEL PRODUCTS)
          MUST BE COMMENCED WITHIN ONE (1) YEAR AFTER THE CLAIM OR CAUSE OF
          ACTION ARISES.
        </p>
        <p>
          NOTWITHSTANDING THE FOREGOING, THIS SECTION DOES NOT EXPAND OR
          LIMIT (I) ANY EXPRESS, WRITTEN PRODUCT WARRANTY OR RELATED DISCLAIMERS
          THAT ARE PROVIDED BY HENKEL OR ITS SUPPLIERS WITH REGARD TO A PHYSICAL
          PRODUCT SOLD BY HENKEL TO YOU, OR ANY WARRANTY ON A PHYSICAL PRODUCT
          TO THE EXTENT REQUIRED BY APPLICABLE LAW; (II) HENKEL PARTIES’
          LIABILITY FOR PERSONAL INJURY TO YOU CAUSED BY HENKEL PARTIES TO THE
          EXTENT NOT WAIVABLE OR CANNOT BE LIMITED UNDER APPLICABLE LAW;
          OR (III) ANY CAUSE OF ACTION YOU MAY HAVE AGAINST HENKEL PARTIES THAT
          IS NOT WAIVABLE OR CANNOT BE LIMITED UNDER APPLICABLE LAW.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Arbitration and Dispute Terms</strong>
        </p>
        <ol type="A" style={{ paddingLeft: '16px' }}>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Forum Selection/Jurisdiction.  For users for are not individual
              residents of the province of Quebec, Jurisdiction and venue for
              any controversy, allegation, or claim arising out of or relating
              to the Service, the Content, your UGC, these Terms, or any
              applicable Additional Terms, (collectively, “Dispute”) shall be in
              Wilmington, Delaware. Each party submits to personal jurisdiction
              and venue in Wilmington, Delaware for any and all purposes.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Pre-Arbitration Notification. Henkel and you agree that it would
              be advantageous to discuss and hopefully resolve any Disputes
              before formal proceedings are initiated; provided, however, that
              Henkel need not do so in circumstances where its claims of
              Intellectual Property rights are concerned (“IP Disputes,” with
              all other disputes referred to as “General Disputes”). The party
              making a claim – whether you or Henkel – shall send a letter to
              the other side briefly summarizing the claim and the request for
              relief. If Henkel is making a claim, the letter shall be sent, via
              email, to the email address listed in your Henkel account, if
              applicable. If no such information exists or if such information
              is not current, then We have no notification or delay obligations
              under this Section 11(b). If you are making a claim, the letter
              shall be sent to Henkel Corporation, One Henkel Way, Rocky Hill,
              CT 06067 (Attn: General Counsel). If the Dispute is not resolved
              within sixty (60) days after notification, the claimant may
              proceed to initiate proceedings as set forth in this Section 11,
              or permitted by the applicable law. Either you or Henkel however,
              may seek provisional remedies (such as preliminary injunctive
              relief, subject to Section 11(d)) before the expiration of this
              sixty (60)-day period.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Arbitration of Claims. As permitted by applicable law, and for
              users who are not individual residents of the province of Quebec,
              all actions or proceedings arising in connection with, touching
              upon or relating to any Dispute, or the scope of the provisions of
              this Section, shall be submitted to JAMS (<a
                href="www.jamsadr.com"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                www.jamsadr.com
              </a>) for final and binding arbitration under its Comprehensive
              Arbitration Rules and Procedures if the matter in dispute is over
              $250,000 or under its Streamlined Arbitration Rules and Procedures
              if the matter in dispute is $250,000 or less, to be held in
              Delaware before a single arbitrator. The arbitrator shall be
              selected by mutual agreement of the parties or, if the parties
              cannot agree, then by striking from a list of arbitrators supplied
              by JAMS. We may have the right to pay the JAMS fees if required
              for arbitration to be enforceable. The arbitration shall be a
              confidential proceeding, closed to the general public; provided,
              however, that a party may disclose information relating to the
              arbitration proceedings to its and its affiliates’ lawyers,
              insurance providers, auditors and other professional advisers. The
              fact that there is a dispute between the parties that is the
              subject of arbitration shall be confidential to the same extent.
              The arbitrator shall issue a written opinion stating the essential
              findings and conclusions upon which the arbitrator’s award is
              based.  Neither party shall be entitled or permitted to commence
              or maintain any action in a court of law with respect to any
              matter in dispute until such matter shall have been submitted to
              arbitration as herein provided and then only for the enforcement
              of the arbitrator’s award; provided, however, that prior to the
              appointment of the arbitrator or for remedies beyond the
              jurisdiction of an arbitrator, at any time, either party may seek
              pendente lite relief (subject to the provisions of these Terms
              waiving or limiting that relief) in a court of competent
              jurisdiction in the state of Delaware  or, if sought by Henkel
              such other court that may have jurisdiction over you, without
              thereby waiving its right to arbitration of the dispute or
              controversy under this Section; provided further, however, that
              the losing party shall have fifteen (15) business days after the
              issuance of the arbitrator’s decision to fully comply with such
              decision, after which the prevailing party may enforce such
              decision by a petition to the courts in Wilmington, Delaware or,
              in the case of you, such other court having jurisdiction over you,
              which may be made ex parte, for confirmation and enforcement of
              the award.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Limitation on Injunctive Relief. AS PERMITTED BY APPLICABLE LAW,
              IF YOU CLAIM THAT YOU HAVE INCURRED ANY LOSS, DAMAGES, OR INJURIES
              IN CONNECTION WITH YOUR USE OF THE SERVICE, THEN THE LOSSES,
              DAMAGES, AND INJURIES WILL NOT BE DEEMED IRREPARABLE OR SUFFICIENT
              TO ENTITLE YOU TO AN INJUNCTION OR TO OTHER EQUITABLE RELIEF OF
              ANY KIND.  THIS MEANS (WITHOUT LIMITATION) THAT, IN CONNECTION
              WITH YOUR CLAIM, YOU AGREE THAT YOU WILL NOT SEEK, AND THAT YOU
              WILL NOT BE PERMITTED TO OBTAIN, ANY COURT OR OTHER ACTION THAT
              MAY INTERFERE WITH OR PREVENT THE DEVELOPMENT OR EXPLOITATION OF
              THE SERVICE, OR ANY ASPECT THEREOF, OR INTELLECTUAL PROPERTY
              OWNED, LICENSED, USED, OR CONTROLLED BY ANY HENKEL
              PARTY (INCLUDING YOUR LICENSED UGC) OR A LICENSOR OF ANY HENKEL
              PARTY.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Governing Law. For users for are not individual residents of the
              province of Quebec, these Terms and any applicable Additional
              Terms, General Disputes and IP Disputes, and any other claim
              brought by you against Henkel or by Henkel against you pursuant to
              this Section 11, or otherwise related to the Service, Content,
              Henkel Licensed Elements, UGC or other Henkel products or
              services, will be governed by, construed, and resolved in
              accordance with, the laws of the State of Delaware, U.S.A.,
              without regard to its conflicts of law provisions that might apply
              the laws of another jurisdiction.  This Section 11 shall be
              governed solely by the Federal Arbitration Act, 9 U.S.C. §1, et
              seq., and not by the law of any state, and is enforceable pursuant
              to its terms on a self-executing basis. You and Henkel agree that
              We intend that this Section 11 satisfies the “writing” requirement
              of the Federal Arbitration Act.  This Section 11 can only be
              amended by mutual agreement.  Either party may seek enforcement of
              this Section 11 in any court of competent jurisdiction. The
              arbitrator shall determine any and all challenges to the
              arbitrability of a claim.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Class Action Waiver. As permitted by applicable law, and for users
              who are not individual residents of the province of Quebec, both
              you and Henkel waive the right to bring any Dispute as a class,
              consolidated, representative, collective, or private attorney
              general action, or to participate in a class, consolidated,
              representative, collective, or private attorney general action
              regarding any Dispute brought by anyone else. Notwithstanding any
              provision in the JAMS Comprehensive Arbitration Rules and
              Procedures to the contrary, the arbitrator shall not have the
              authority or any jurisdiction to hear the arbitration as a class,
              consolidated, representative, or private attorney general action
              or to consolidate, join, or otherwise combine the Disputes of
              different persons into one proceeding. Notwithstanding the
              arbitration provision set forth above, if the provision regarding
              waiver of class, collective, representative, and private attorney
              general claims of this Section 11 is found to be void or otherwise
              unenforceable, any such class, collective, representative, or
              private attorney general claims must be heard and determined
              through an appropriate court proceeding, and not in arbitration.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Jury Waiver. AS PERMITTED BY APPLICABLE LAW, THE PARTIES HEREBY
              WAIVE THEIR RIGHT TO JURY TRIAL WITH RESPECT TO ALL CLAIMS AND
              ISSUES ARISING UNDER, IN CONNECTION WITH, TOUCHING UPON OR
              RELATING TO THESE TERMS, THE BREACH THEREOF AND/OR THE SCOPE OF
              THE PROVISIONS OF THIS SECTION, WHETHER SOUNDING IN CONTRACT OR
              TORT, AND INCLUDING ANY CLAIM FOR FRAUDULENT INDUCEMENT THEREOF.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Small Claims Matters.  Notwithstanding the foregoing, either of us
              may bring qualifying claim of General Dispute (but not IP
              Disputes) in small claims court, subject to Section 11(f).
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Supersede. The provisions of this Section 11 shall supersede any
              inconsistent provisions of any prior agreement between the
              parties. This Section 11 shall remain in full force and effect
              notwithstanding any termination of your use of the Service or
              these Terms.
            </p>
          </li>
        </ol>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Downloaded Software</strong>
        </p>
        <p>
          If you download software from the Service, the software and all files,
          images and data relating to the software is subject to the license
          terms in the software license that accompanies or is provided with the
          software. You may only use the software pursuant to the terms of such
          software license. You do not own the downloaded software, and Henkel
          does not transfer ownership of the software to you. You may not
          redistribute, sell, decompile, reverse engineer, disassemble, or
          otherwise reduce the software to a human-perceivable form.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Update to Terms</strong>
        </p>
        <p>
          It is your responsibility to review the posted Terms and any
          applicable Additional Terms each time you use this  SERVICE YOU ARE
          ENTERING INTO A NEW AGREEMENT WITH US ON THE THEN APPLICABLE TERMS AND
          CONDITIONS AND YOU AGREE THAT WE MAY NOTIFY YOU OF NEW TERMS BY
          POSTING THEM ON THE SERVICE (OR IN ANY OTHER REASONABLE MANNER OF
          NOTICE WHICH WE ELECT), AND THAT YOUR USE OF THE SERVICE AFTER SUCH
          NOTICE CONSTITUTES YOUR GOING FORWARD AGREEMENT TO THE NEW TERMS FOR
          YOUR NEW USE AND TRANSACTIONS. Any new Terms or Additional Terms will
          be effective as to new use and transactions as of the time that We
          post them, or such later date as may be specified in them or in other
          notice to you. In the event any notice to you of new, revised, or
          additional terms is determined by a tribunal to be insufficient, the
          prior agreement shall continue until sufficient notice to establish a
          new agreement occurs. You can reject any new, revised or additional
          terms by discontinuing use of the Service.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Forward-looking Statements</strong>
        </p>
        <p>
          The Service may contain statements that involve Henkel´s intentions,
          expectations or predictions. Such statements reflect the views of
          Henkel as of the date made with respect to future events and are
          subject to risks and uncertainties. These statements could be
          inaccurate or could become inaccurate as a result of developments
          occurring after their respective dates. Henkel disclaims any intention
          or obligation to update or revise these statements.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Severability/No Waiver, Entire Agreement</strong>
        </p>
        <p>
          If any provision of these Terms shall be found to be unlawful, void,
          or for any reason unenforceable, then that provision shall be deemed
          severable from these Terms and shall not affect the validity and
          enforceability of any remaining provisions. No failure on the part of
          Henkel to enforce these Terms shall constitute a waiver of any of
          Henkel´s rights under these Terms, whether for past or future actions
          on the part of any person. These Terms shall be the entire agreement
          between Henkel and you with respect to the subject matter hereto, and
          supersede all prior or contemporaneous understandings regarding such
          subject matter. No amendment to or modification of this Terms will be
          binding unless provided as an update by Henkel to this document, or
          signed in writing by an authorized officer of Henkel.
        </p>
      </li>
    </ol>
    <h2>Privacy Statement</h2>
    <br />
    <p>
      Thank you for visiting a website, mobile app or other online
      service (“Service”) that belongs to Us and is operated by Henkel
      Corporation or one of its subsidiary or affiliated companies (“Henkel”,
      “Us”, “We”, “Our”).  This Privacy Statement outlines the information
      Henkel may be collecting and how We use and protect that information.
    </p>
    <p>
      Click <a
        href="https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank"
        style={{ textDecoration: 'underline' }}
        target="_blank"
        rel="noopener noreferrer"
      >
        here
      </a> to view Our Terms of Use. California residents, see Section 12A to
      view your California privacy rights.
    </p>
    <p>
      <i>Effective as of:  November 14, 2017</i>
    </p>
    <ol style={{ paddingLeft: '16px' }}>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Scope</strong>
        </p>
        <p>
          This Privacy Statement applies to your use of any Service (e.g.,
          website, mobile app or internet-connected product) that posts a link
          to, or otherwise provides notice of the applicability of, this Privacy
          Statement, regardless of how you access or use it. It does not apply
          to information We obtain in Our capacity as an employer except with
          respect to employment applications and inquiries received via the
          Service. This Privacy Statement applies to Our collection, use and
          disclosure of information about you through the Service and does not
          apply to Our activities off of the Service or third party websites
          accessible via hyperlinks found on a Henkel Service.
        </p>
        <p>
          For certain aspects of the Service, there may be additional notices
          about information practices and choices. Please read those additional
          privacy disclosures to understand how they apply to you.
        </p>
        <p>
          By using Our Service in any way, such as browsing or interacting, you
          signify that you agree with the terms of Our current Privacy Statement
          as posted here and Our Service Terms of Use found <a
            href="https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank"
            style={{ textDecoration: 'underline' }}
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>. If you do not consent to Our practices as described in this
          Privacy Statement, you may and should not use Our Service.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Revisions</strong>
        </p>
        <p>
          Henkel reserves the right to change this Privacy Statement
          prospectively effective upon the posting of the revised Privacy
          Statement and your use of the Service indicates your consent to the
          privacy statement posted at the time of use.  However, We will not use
          your previously collected Henkel-Collected PI (defined below), to the
          extent it is not collected under the new privacy statement, in a
          manner materially different than represented at the time it was
          collected without your consent. To the extent any provision of this
          Privacy Statement is found by a competent tribunal to be invalid or
          unenforceable, such provision shall be severed to the extent necessary
          for the remainder to be valid and enforceable.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Information Collected</strong>
        </p>
        <p>
          You can visit Our Service without telling Us who you are or revealing
          personal information about yourself, however, doing so may render
          certain Henkel service’s unavailable to you. You may, however, choose
          to provide (“Personal Information”) (defined as information that
          identifies you personally, such as your first and last name, e-mail
          address, phone number, address, and full payment account number).
        </p>
        <p>
          The types of information that Henkel may collect about you include,
          but are not limited to:
        </p>
        <ul style={{ paddingLeft: '16px', listStyle: 'circle' }}>
          <li>
            <p>
              Contact information (such as name, address, city, state,
              province/territory, Postal/ZIP code, email address and telephone
              number).
            </p>
          </li>
          <li>
            <p>Product preferences.</p>
          </li>
          <li>
            <p>
              “Demographic information” such as age range, gender, date of
              birth, marital status, Postal/ZIP code, and household
              composition). Except to the extent required by applicable law,
              Demographic Information is “non-Personal Information” (i.e., data
              that is not Personal Information under this Privacy Statement).
            </p>
          </li>
          <li>
            <p>
              “Usage Information” such as IP address, device identifier, browser
              type, operating system, information about your use of the Service,
              and data regarding network connected hardware (e.g., computer or
              mobile device). Except to the extent required by applicable law,
              or to the extent Usage Information is combined by or on behalf of
              Henkel with Personal Information, Henkel does not consider Usage
              Information (including, without limitation, unique device
              identifiers) to be Personal Information or Henkel-Collected PI.
            </p>
          </li>
          <li>
            <p>
              Social Security Number (“SSN”)(in limited circumstances Henkel may
              collect SSN, for example if you win a sweepstakes or receive
              compensation that must be reported for government tax purposes).
            </p>
          </li>
          <li>
            <p>
              Photographs and videos (e.g., that are submitted by customers via
              websites such as part of contests or sweepstakes).
            </p>
          </li>
          <li>
            <p>
              Employment application information (such as SSN, Driver’s license,
              financial information, background screening, and gender or race
              [as permitted by law]).
            </p>
          </li>
        </ul>
        <p>
          If you choose to participate in the Service activities such as website
          registrations, contests, sweepstakes, questionnaires, surveys,
          consumer service contacts, product purchases, mobile applications,
          social media platforms, or through Our Career Center or employment
          inquiries, Henkel will collect the Personal Information that you
          provide (“Henkel-Collected PI”). We may enhance or merge the
          information that you provide to Us directly with information from
          other sources, including third parties for the purposes described
          below. To the extent any information is combined by or on behalf of
          Henkel with Henkel-Collected-PI, Henkel will treat the combined data
          as Henkel-Collected PI under this Privacy Statement.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Information Use</strong>
        </p>
        <p>
          We collect, maintain and use your Henkel-Collected-PI, other Personal
          Information, and other information, for purposes not inconsistent with
          this Privacy Statement or any written statements We make at the time
          of collection, such as for:
        </p>
        <ul style={{ paddingLeft: '16px', listStyle: 'disc' }}>
          <li>
            <p>
              establishing and verifying the identity and eligibility of users;
            </p>
          </li>
          <li>
            <p>
              uploading and displaying your postings and similar submitted
              content (“User Generated Content” or “UGC”). (For more information
              on how UGC is treated under the Service’s Terms of Use click <a
                href="https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                here
              </a> [Section 6 of ToU]. For more on the public nature of UGC, see
              Section 5);
            </p>
          </li>
          <li>
            <p>
              opening, maintaining, administering and servicing users profiles,
              accounts or memberships;
            </p>
          </li>
          <li>
            <p>
              processing, servicing or enforcing transactions and sending
              related communications;
            </p>
          </li>
          <li>
            <p>providing products, services and support to users;</p>
          </li>
          <li>
            <p>
              conducting sweepstakes, surveys and contests, and providing the
              results thereof;
            </p>
          </li>
          <li>
            <p>
              operating and improving the Service, including tailoring it to
              users‘ preferences;
            </p>
          </li>
          <li>
            <p>providing users with product or service updates;</p>
          </li>
          <li>
            <p>
              sending promotional notices, offers or other targeted marketing,
              and other information;
            </p>
          </li>
          <li>
            <p>
              responding to your questions, inquiries, comments and
              instructions;
            </p>
          </li>
          <li>
            <p>maintaining the security and integrity of Our systems;</p>
          </li>
          <li>
            <p>understanding consumer preferences across multiple brands;</p>
          </li>
          <li>
            <p>maintaining customer relationships;</p>
          </li>
          <li>
            <p>evaluating product performance and safety;</p>
          </li>
          <li>
            <p>
              complying with policies, procedures and legal requirements; and
            </p>
          </li>
          <li>
            <p>
              improving or products and services and Our other business
              purposes.
            </p>
          </li>
        </ul>
        <br />
        <p>
          Information that you provide when applying for a job or an internship
          via Our Careers Center is used to provide you with information about
          employment opportunities, to administer the application process and
          consider you for employment. Where applicable, in conjunction with
          laws and regulations enforced by the Equal Employment Opportunity
          Commission (“EEOC”), the Office of Federal Contract Compliance
          Programs (“OFCCP”) and similar state and local regulatory agencies, We
          may ask you to provide Us with self-identifying information (such as
          veteran status, gender and ethnicity). Providing such self-identifying
          information is voluntary, but if you do provide Us with such
          information, We may submit that information, to the EEOC, the OFCCP
          and similar state and local regulatory agencies or otherwise use or
          disclose it for business-related purposes, including, without
          limitation, responding to information requests, fulfilling regulatory
          reporting requirements and defending against employment related
          complaints.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Information You Disclose Publicly or to Others</strong>
        </p>
        <p>
          The Service may permit you to post or submit UGC including, without
          limitation, written content, user profiles, audio or visual
          recordings, computer graphics, pictures, data, or other content,
          including Personal Information.  If you choose to submit UGC to any
          public area of the Service, your UGC will be considered “public” and
          will be accessible by anyone, including Henkel.  Notwithstanding
          anything to the contrary, and subject to the applicable law, unless
          otherwise explicitly agreed by Us, Personal Information included in
          UGC is not subject to Henkel’s usage or sharing limitations, or other
          obligations, regarding Henkel-Collected-PI or other Personal
          Information under this Privacy Statement or otherwise, and may be used
          and shared by Henkel and third parties to the fullest extent not
          prohibited by applicable law.  Henkel encourages you to exercise
          caution when making decisions about what you disclose in such public
          areas.  For more information on how UGC is treated under the Service’s
          Terms of Use click <a
            href="https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank"
            style={{ textDecoration: 'underline' }}
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a> [Section 6 of ToU].
        </p>
        <p>
          Additionally, the Service may offer you the option to send a
          communication to a friend or other contact. If so, Henkel relies on
          you to only send to people that have given you permission to do so.
          The recipient’s Personal Information you provide (e.g., name, e-mail
          address) will be used to facilitate the communication, but not used by
          Henkel for any other marketing purpose unless Henkel obtains consent
          from that person. Your full name, contact information and message may
          be included in the communication.  For residents of Canada, you may
          only provide us with the contact information of friends with whom you
          have had direct voluntary two way communications, and with whom it is
          reasonable to conclude you have a personal relationship considering
          shared interests, experiences, opinions and other relevant factors.
          You may only provide email addresses of family members to whom you are
          related by marriage, a common-law partnership, or parent-child
          relationship, and with whom you have had direct voluntary two way
          communications.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Technology Logging, Cookies, and Related Techniques</strong>
        </p>
        <p>
          When you interact with Our Service, your browser or device may
          communicate with the technology that We use as part of Our Service.
          For example, as you use Our Service, your browser communicates with
          Our technology, which in turn keeps records of your interactivity and
          requests for services and content to assist Us in managing and
          improving the utility of Our Service, and to conduct research and
          analysis on its use. The types of such Usage Information may include
          your Internet Protocol (IP) address, browser type, URL, requests made,
          pages visited, activities conducted on the page, day and time of visit
          and related technical usage information.
        </p>
        <p>
          Cookies and other tracking technologies now and hereafter developed
          (“Tracking Technologies”) may be used to collect information about
          interactions with the Service or e-mails, including information about
          your browsing and purchasing behavior, to authenticate you to the
          Service, to analyze how the Service is used, to link information about
          how you use the Service with your account, and to help tailor Our
          services. We use these technical means and so do Our Affiliates,
          business partners, and Service Providers. To help Us measure Service
          activity and provide a better user experience, We may allow Our
          Service Providers or business partners to compile information such as
          that identified above from Tracking Technologies. We may also allow
          Our third party advertising and personalization partners to collect
          and use this information to develop personalized content and
          appropriate advertising (including for companies not affiliated with
          Us) based on your visits over time on Henkel and non-Henkel websites,
          apps and other online services. You may see these advertisements on
          other websites, apps and online services. This information may also be
          used to evaluate Our and third party online advertising campaigns or
          to tailor promotions and other marketing messages to you on Our
          Service and other websites apps and online services.
        </p>
        <p>
          A cookie is a small text file that is stored on a user’s device, which
          may be session ID cookies or tracking cookies. Session cookies make it
          easier for you to navigate the Service and expire when you close your
          browser. Tracking cookies remain longer and help in understanding how
          you use the Service, and enhance your user experience. Cookies may
          remain on your hard drive for an extended period of time. If you use
          your browser’s method of blocking or removing cookies, some but not
          all types of cookies may be deleted and/or blocked and as a result
          some features and functionalities of the Service may not work. A Flash
          cookie (or locally shared object) is a data file which may be placed
          on a device via the Adobe Flash plug-in that may be built-in to or
          downloaded by you to your device. HTML5 cookies can be programmed
          through HTML5 local storage. Flash cookies and HTML5 cookies are
          locally stored on your device other than in the browser and browser
          settings won’t control them. To identify certain types of local shared
          objects on your device and adjust your settings, please visit: <a
            href="www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager.html"
            style={{ textDecoration: 'underline' }}
            target="_blank"
            rel="noopener noreferrer"
          >
            www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager.html
          </a>. The Service may associate some or all of these types of cookies
          with your devices. Other types of Tracking Technologies may include
          web beacons (also known as “tracking pixels”), embedded scripts,
          location-identifying technologies, fingerprinting, device recognition
          technologies, and in-app tracking methods. See Section 11 regarding
          certain choices regarding these activities.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Data Sharing and Storage</strong>
        </p>
        <p>
          Henkel may disclose your information to third parties to the extent
          not inconsistent with this Privacy Statement or other written
          statements made by Us at the time of collection, and not prohibited by
          applicable law, including without limitation as follows:
        </p>
        <ul style={{ paddingLeft: '16px', listStyle: 'disc' }}>
          <li>
            <p>
              Henkel’s agents, vendors, consultants, and other service providers
              (collectively “Service Providers”) may receive, or be given access
              to your information, including, without limitation,
              Henkel-Collected-PI and other Personal Information, Demographic
              Information, and Usage Information, in connection with their work
              on Henkel’s behalf, provided however, Henkel does not authorize
              its Service Providers to use Henkel-Collected-PI to send you
              direct marketing messages other than related to Henkel and Henkel
              Affiliates absent your consent. For more information on choices
              Service Providers may offer you see Section 11.
            </p>
          </li>
          <li>
            <p>
              We reserve the right to release your Henkel-Collected-PI and other
              Personal Information if required to do so by law, search warrant,
              subpoena, court order or upon request of government authorities.
            </p>
          </li>
          <li>
            <p>
              We may provide your Henkel-Collected-PI and other Personal
              Information, and other information, to third parties in connection
              with the reorganization, merger, sale, joint venture, assignment,
              transfer, or other disposition of all or any portion of Our
              business, assets, or stock, including any such activities
              associated with a bankruptcy or similar proceeding.
            </p>
          </li>
          <li>
            <p>
              Henkel may share your Personal Information with its affiliated
              companies and subsidiaries (“Affiliates”), and other third
              parties, some of which may be located outside of the United
              States, for marketing and other business activities, subject to
              certain rights of residents of California and Connecticut  [see
              Section 12].
            </p>
          </li>
        </ul>
        <br />
        <p>
          Your Personal Information may be stored for a reasonable amount of
          time in Henkel databases, some of which are located outside of the
          United States and Canada, and will be automatically transferred to
          these databases for storage and maintenance. The Service is based in
          the U.S., intended for residents of the U.S. and Canada and for
          persons outside Canada, the information Henkel and its Service
          Providers collect via the Service is governed by U.S. law. If you are
          accessing the Service from outside of the U.S., please be aware that
          information collected through the Service may be transferred to,
          processed, stored, and used in the U.S. Data protection laws in the
          U.S. may be different from those of your country of residence and
          provide a lower level of consumer protection, and information
          transferred to the U.S. may be accessed by U.S. governments and law
          enforcement in accordance with U.S. laws. Your use of the Service, or
          provision of any information via the Service, therefore constitutes
          your consent to the transfer to and from, processing, usage, sharing,
          and storage of your information, including Personal Information, in
          the U.S. as set forth in this Privacy Statement.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>
            Third-Party Content, Third-Party Services, Social Features,
            Advertising and Analytics
          </strong>
        </p>
        <p>
          The Service may include hyperlinks to, or include on or in connection
          with, the Service (e.g., apps and plug-ins), websites, locations,
          platforms, applications or services operated by third parties
          (“Third-Party Service(s)”). These Third-Party Services may use their
          own cookies, web beacons, and other Tracking Technologies to
          independently collect information about you and may solicit Personal
          Information from you.  Henkel is not responsible for the privacy
          practices or the content of the Third-Party Services. Please note that
          the privacy statements applicable to such Third-Party Services may
          differ significantly from the Henkel Privacy Statement, so We advise
          you to read them carefully before using those services. You agree that
          Henkel shall not be held liable for any actions by or content of such
          Third-Party Services.
        </p>
        <p>
          Certain functionalities on the Service permit interactions that you
          initiate between the Service and certain Third-Party Services, such as
          third party social networks (“Social Features”).  Examples of Social
          Features include: enabling you to send content such as contacts and
          photos between the Service and a Third-Party Service; “liking” or
          “sharing” Henkel’s content; logging in to the Service using your
          Third-Party Service account (e.g., using Facebook Connect to sign-in
          to the Service); and to otherwise connect the Service to a Third-Party
          Service (e.g., to pull or push information to or from the Service). If
          you use Social Features, and potentially other Third-Party Services,
          information you post or provide access to may be publicly displayed on
          the Service (see Section 5) or by the Third-Party Service that you
          use. Similarly, if you post information on a third-party service that
          references the Service (e.g., by using a hashtag associated with
          Henkel or other Henkel Affiliates in a tweet or status update), you
          agree that your post may be used on or in connection with the Service
          or otherwise by Henkel or other Henkel Affiliates. Also, both Henkel
          and the third party may have access to certain information about you
          and your use of the Service and any Third-Party Service.
        </p>
        <p>
          Henkel may engage and work with Service Providers and other third
          parties to serve advertisements on the Service and/or on third-party
          services.  Some of these ads may be tailored to your interest based on
          your browsing of the Service and elsewhere on the internet, sometimes
          referred to as “interest-based advertising” and “online behavioral
          advertising” (“Interest-based Advertising”), which may include sending
          you an ad on a Third-Party Service after you have left the Service
          (i.e., “retargeting”).  As an example, the Service may employ a
          “DoubleClick id-Cookie,” which may assign a pseudonymized identifier
          to, among other things, track DoubleClick advertising. DoubleClick is
          a service provided by Google. For information on your ability to
          opt-out of Interest-based Advertising see section 11 below.
        </p>
        <p>
          Henkel may use Google Analytics, Adobe Analytics or other Service
          Providers for analytics services.  These analytics services may use
          cookies and other Tracking Technologies to help Henkel analyze Service
          users and how they use the Service.  Information generated by these
          services (e.g., your IP address and other Usage Information) may be
          transmitted to and stored by these Service Providers on servers in the
          U.S. (or elsewhere) and these Service Providers may use this
          information for purposes such as evaluating your use of the Service,
          compiling statistic reports on the Service’s activity, and providing
          other services relating to Service activity and other Internet usage.
        </p>
        <p>
          Except to the extent We combine information We receive from Service
          Providers, Third-Party Services, or other third parties with
          Henkel-Collected PI, in which case Henkel will treat the combined
          information as Henkel-Collected PI under this Privacy Statement, data
          obtained by Henkel from a third party, even in association with the
          Service, is not subject to Henkel’s limitations regarding
          Henkel-Collected PI under this Privacy Statement, however such data
          remains subject to any restrictions imposed on Henkel by the third
          party, if any.  Otherwise, the information collected, stored, and
          shared by third parties remains subject to their privacy policies and
          practices, including whether they continue to share information with
          Henkel, the types of information shared, and your choices on what is
          visible to others on Third-Party Services.
        </p>
        <br />
        <p>
          Henkel is not responsible for and makes no representations regarding
          the policies or business practices of any third parties, including,
          without limitation, analytics Service Providers and Third-Party
          Services associated with the Service, and encourages you to
          familiarize yourself with and consult their privacy policies and terms
          of use.  See Section 11 for more on certain choices offered by some
          third parties regarding their data collection and use, including
          regarding Interest-based Advertising and analytics.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Security and Monitoring</strong>
        </p>
        <p>
          Henkel will take reasonable precautions to protect your Personal
          Information (excluding public UGC) from loss, misuse or alteration.
          Personal Information may be accessed by persons within Our
          organization, or Our third party service providers, who require such
          access to carry out the purposes indicated above, or such other
          purposes as may be permitted or required by the applicable law. Please
          be aware, however, that any email or other transmission you send
          through the Internet cannot be completely protected against
          unauthorized interception and that the internet and online digital
          storage are not completely secure and We do not guarantee the security
          of your information collected through the Service.
        </p>
        <p>
          To help protect you and others, We and Our Service Providers may (but
          make no commitment to) monitor use of the Service, and may collect and
          use related information including Henkel-Collected PI and other
          Personal Information for all purposes not prohibited by applicable law
          or inconsistent with this Privacy Statement, including, without
          limitation, to identify fraudulent activities and transactions;
          prevent abuse of and investigate and/or seek prosecution for any
          potential threats to or misuse of the Service; ensure compliance with
          the <a
            href="https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank"
            style={{ textDecoration: 'underline' }}
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Use
          </a> and this Privacy Statement; investigate violations of or enforce
          these agreements; and otherwise to protect the rights and property of
          Henkel, our Affiliates third parties, and other users. Monitoring may
          result in the collection, recording, and analysis of online activity
          or communications through Our Service.  If you do not consent to these
          conditions, you must discontinue your use of the Service.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Children</strong>
        </p>
        <p>
          The Service is intended for a general audience and not directed to
          children less than 13 years of age. Henkel does not intend to collect
          personal information as defined by the U.S. Children’s Online Privacy
          Protection Act (“COPPA”) (“Children’s Personal Information”) in a
          manner that is not permitted by COPPA. If We obtain knowledge that We
          have collected Children’s Personal Information in a manner not
          permitted by COPPA or other applicable law, We will remove such data
          to the extent required by COPPA or such other applicable law.
        </p>
        <p>
          Any California residents under the age of eighteen (18) who have
          registered to use the Service, and who posted content or information
          on the Service, can request removal by contacting Henkel <a
            href="https://www.henkel-northamerica.com/contact-us"
            style={{ textDecoration: 'underline' }}
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a> detailing where the content or information is posted and
          attesting that you posted it. Henkel will then make reasonable good
          faith efforts to remove the post from prospective public view or
          anonymize it so the minor cannot be individually identified to the
          extent required by applicable law. This removal process cannot ensure
          complete or comprehensive removal. For instance, third-parties may
          have republished or archived content by search engines and others that
          Henkel does not control.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Your Choices Regarding Your Personal Information</strong>
        </p>
        <ol type="A" style={{ paddingLeft: '16px' }}>
          <li style={{ marginBottom: '16px' }}>
            <p>
              <strong>Tracking Technologies Generally</strong>
            </p>
            <p>
              Regular cookies may generally be disabled or removed by tools
              available as part of most commercial browsers, and in some
              instances blocked in the future by selecting certain settings.
              Browsers offer different functionalities and options so you may
              need to set them separately. Also, tools from commercial browsers
              may not be effective with regard to Flash cookies (also known as
              locally shared objects), HTML5 cookies, or other Tracking
              Technologies. For information on disabling Flash cookies, go to
              Adobe’s website <a
                href="helpx.adobe.com/flash-player/kb/disable-third-party-local-shared.html"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                http://helpx.adobe.com/flash-player/kb/disable-third-party-local-shared.html
              </a>. Please be aware that if you disable or remove these
              technologies, some parts of the Service may not work and that when
              you revisit the Service your ability to limit browser-based
              Tracking Technologies is subject to your browser settings and
              limitations.
            </p>
            <p>
              Some App-related Tracking Technologies in connection with
              non-browser usage (e.g., most functionality of a mobile app) can
              only be disabled by uninstalling the app. To uninstall an app,
              follow the instructions from your operating system or handset
              manufacturer.
            </p>
            <p>
              Your browser settings may allow you to automatically transmit a
              “Do Not Track” signal to online services you visit. Note, however,
              there is no consensus among industry participants as to what “Do
              Not Track” means in this context. Like many online services,
              Henkel currently does not alter Henkel’s practices when Henkel
              receives a “Do Not Track” signal from a visitor’s browser. To find
              out more about “Do Not Track,” you can visit <a
                href="http://www.allaboutdnt.com"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                http://www.allaboutdnt.com
              </a>, but We are not responsible for the completeness or accuracy
              of this third party information. Some third parties, however, may
              offer you choices regarding their Tracking Technologies. One way
              to potentially identify cookies on Our Site is to add the free
              Ghostery plug-in to your browser (<a
                href="www.ghostery.com"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                www.ghostery.com
              </a>), which according to Ghostery will display for you
              traditional, browser-based cookies associated with the web sites
              (but not mobile apps) you visit and privacy and opt-out policies
              and options of the parties operating those cookies. Henkel is not
              responsible for the completeness or accuracy of this tool or third
              party choice notices or mechanisms. For specific information on
              some of the choice options offered by third party analytics and
              advertising providers, see the next section.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              <strong>Analytics and Advertising Tracking Technologies</strong>
            </p>
            <p>
              You may exercise choices regarding the use of cookies from Google
              Analytics by going to <a
                href="https://tools.google.com/dlpage/gaoptout"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                https://tools.google.com/dlpage/gaoptout
              </a> or downloading the Google Analytics Opt-out Browser Add-on.
              You may exercise choices regarding the use of cookies from Adobe
              Analytics by going to <a
                href="http://www.adobe.com/privacy/opt-out.html"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                http://www.adobe.com/privacy/opt-out.html
              </a> under the section labeled “Tell Our customers not to measure
              your use of their websites or tailor their online ads for you.”
              You may exercise choices regarding the use of cookies from Google
              DoubleClick by going to <a
                href="http://www.google.com/settings/ads?hl=en&sig=ACi0TCgXcUy18Z6Kz1pyakm7pX-B1M877ZOZM4fyhX3MaQy-Iki2ybWNEgma-KMfvA7dEIUaKxnTeqojTguFHK3SeHycKTZ1Ew"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                http://www.google.com/settings/ads?hl=en&sig=ACi0TCgXcUy18Z6Kz1pyakm7pX-B1M877ZOZM4fyhX3MaQy-Iki2ybWNEgma-KMfvA7dEIUaKxnTeqojTguFHK3SeHycKTZ1Ew
              </a>. Henkel is not responsible for effectiveness of, or
              compliance with, any third-parties’ opt-out options or programs or
              the accuracy of their statements regarding their programs.
            </p>
            <p>
              You may choose whether to receive some Interest-based Advertising
              by submitting opt-outs to industry programs. Some of the
              advertisers and Service Providers that perform advertising-related
              services for Us and third parties may participate in the Digital
              Advertising Alliance’s (“DAA”) Self-Regulatory Program for Online
              Behavioral Advertising. To learn more about how you can exercise
              certain choices regarding Interest-based Advertising, visit <a
                href="http://www.aboutads.info/choices"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                http://www.aboutads.info/choices
              </a>, and <a
                href="http://www.aboutads.info/appchoices"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                http://www.aboutads.info/appchoices
              </a> for information on the DAA’s opt-out program for mobile apps.
              Some of these companies may also be members of the Network
              Advertising Initiative (“NAI”). To learn more about the NAI and
              your opt-out options for their members, see <a
                href="http://www.networkadvertising.org/choices/"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                http://www.networkadvertising.org/choices/
              </a>. Please be aware that, even if you are able to opt out of
              certain kinds of Interest-based Advertising, you may continue to
              receive other types of ads. Opting out only means that those
              selected members should no longer deliver certain Interest-based
              Advertising to you, but does not mean you will no longer receive
              any targeted content and/or ads (e.g., from other ad networks).
              Some companies also provide a specific opportunity to opt-out. For
              information on the Interest-based Advertising choices offered by
              DoubleClick, see <a
                href="https://www.google.com/settings/u/0/ads/plugin?hl=en&sig=ACi0TCigvVYAN17ugYRMwQf_InKv4i5GKLPNen5UUD8qFqiWU4vtXR5jsz_uaOHdJqvhufEjezDh-Q13icRRRab9WJDGpQbwkQ"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                here
              </a>. Also, if your browsers are configured to reject cookies when
              you visit these opt-out webpages, or you subsequently erase your
              cookies, use of a different device or web browsers or use a
              non-browser-based method of access (e.g., mobile app), your
              browser-based opt-out may not, or may no longer, be effective.
              Henkel supports the ad industry’s <a
                href="www.iab.net/media/file/ven-principles-07-01-09.pdf"
                style={{ textDecoration: 'underline' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                2009 Self-regulatory Principles for Online Behavioral
                Advertising
              </a> and expects that ad networks Henkel directly engages to serve
              you Interest-based Advertising will do so as well, though Henkel
              cannot guaranty their compliance. Henkel is not responsible for
              effectiveness of, or compliance with, any third-parties’ opt-out
              options or programs or the accuracy of their statements regarding
              their programs.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              <strong>Mobile Apps</strong>
            </p>
            <p>
              With respect to Henkel’s mobile apps (“apps”), you can stop all
              collection of data generated by use of the app by uninstalling the
              app.  Also, you may be able to exercise specific privacy choices,
              such as enabling or disabling certain features (e.g.,
              location-based services, push notifications, accessing
              calendar/contacts/phots, etc.), by adjusting the permissions in
              your mobile device and/or the app’s settings. Beware that if GPS
              precise location services are disabled, other means of
              establishing or estimating location (e.g., connecting to or
              proximity to wi-fi, Bluetooth, beacons, or Our networks) may
              persist.  See also the prior section regarding the DAA’s mobile
              Interest-based Advertising choices.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              <strong>Communications</strong>
            </p>
            <p>
              You can opt out of receiving certain promotional
              communications (emails or text messaging) from Henkel at any time
              by (i) for promotional e-mails, following the instructions
              provided in emails to click on the unsubscribe link, or if
              available by changing your communication preferences by logging
              onto your account; and (ii) for text messages, following the
              instructions provided in text messages from Henkel to text the
              word, “STOP”; and (iii) for app push notifications turn off push
              notifications on the settings of your device and/or the app, as
              applicable.  Please note that your opt-out is limited to the
              e-mail address or phone number used and will not affect subsequent
              subscriptions.  If you opt-out of only certain communications,
              other subscription communications may continue.  Even if you opt
              out of receiving promotional communications, Henkel may, subject
              to applicable law, continue to send you non-promotional
              communications, such as those about your account, transactions,
              servicing, or Our ongoing business relations.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              <strong>Careers Center</strong>
            </p>
            <p>
              If you have created a resume using Our Careers Center you may
              access, review, correct, update, change or delete your account
              profile information or resume at any time. Simply log into your
              account, go to your profile or resume, and make the necessary
              changes. You may delete your resume from Our online database at
              any time by accessing your account; provided, however, that We
              reserve the right to maintain a copy (a) as required by applicable
              law; and (b) for so long as reasonably necessary for record
              keeping purposes except to the extent prohibited by applicable
              law.
            </p>
          </li>
        </ol>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Your California and Connecticut Privacy Rights</strong>
        </p>
        <ol type="A" style={{ paddingLeft: '16px' }}>
          <li style={{ marginBottom: '16px' }}>
            <p>
              California Rights: Henkel provides California residents with the
              option to opt-in or opt-out to sharing of “personal information”
              as defined by California’s “Shine the Light” law with third
              parties, other than Henkel Affiliates, for such third parties own
              direct marketing purposes.  California residents may exercise that
              opt-out, and/or request information about Henkel’s compliance with
              the Shine the Light law, and obtain disclosure of third parties
              Henkel has shared information in accordance with the law for their
              direct marketing purposes absent your choice and the categories of
              information shared, by contacting Henkel <a
                href="mailto:PrivacyNA@henkel.com"
                style={{ textDecoration: 'underline' }}
              >
                here
              </a> or by sending a letter to Henkel at:
            </p>
            <p>
              Attention: Henkel Privacy Inquiries
              <br />
              Communications Department
              <br />
              Henkel Corporation
              <br />
              One Henkel Way
              <br />
              Rocky Hill, CT 06067
            </p>
            <p>
              Requests must include “California Privacy Rights Request” in the
              first line of the description and include your name, street
              address, city, state, and ZIP code.  Please note that Henkel is
              only required to respond to one request per customer each year,
              and Henkel is not required to respond to requests made by means
              other than through the provided e-mail address or mail address.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              Connecticut Rights:Connecticut law requires any person or entity
              that collects Social Security numbers from Connecticut residents
              in the course of business to create a privacy protection policy
              and to publish or display it publicly.  It is Our policy to
              protect the confidentiality of Social Security numbers in Our
              possession from misuse and improper disclosure by maintaining and
              enforcing policies and physical and electronic safeguards against
              misuse and improper disclosure.  Unlawful disclosure of Social
              Security numbers is prohibited, and access to them is limited to
              personnel who need access to such information in order to perform
              their job functions.
            </p>
          </li>
        </ol>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Mobile Applications Privacy Statement</strong>
        </p>
        <p>
          Henkel has developed certain mobile applications that you may download
          to your mobile device. When you download a mobile application there
          may be an opportunity for you to provide Us with or for Us to obtain
          information about you such as contact information, product
          preferences, photographs, or other information. In addition, We may
          obtain information about the mobile device, such as device ID and
          operating system, and app usage. Information obtained through a mobile
          application will be used in accordance with this Privacy Statement and
          may be subject to additional terms posted within the mobile
          application.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Accessing and Changing Information</strong>
        </p>
        <p>
          Henkel may provide web pages or other mechanisms allowing you to
          delete, correct, or update some of the Henkel-Collected PI, and
          potentially certain other information about you (e.g., profile and
          account information). You may also request access to your Personal
          Information and to request a correction to it if you believe it is
          inaccurate using the contact information provided below. We may
          require you to verify your identity before allowing you to access your
          information. Henkel will make good faith efforts to make requested
          changes in Henkel’s then-active databases as soon as practicable, but
          it is not always possible to completely change, remove or delete all
          of your information or public postings from Henkel’s databases
          Further, We reserve the right to retain data (a) as required by
          applicable law; and (b) for so long as reasonably necessary to fulfill
          the purposes for which the data is retained except to the extent
          prohibited by applicable law.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Questions</strong>
        </p>
        <p>
          Please send Us your questions or comments regarding Our privacy
          practices by emailing Us at <a
            href="mailto:PrivacyNA@henkel.com"
            style={{ textDecoration: 'underline' }}
          >
            PrivacyNA@henkel.com
          </a>, or sending Us a letter addressed to:
        </p>
        <p>
          Henkel Privacy Inquiries
          <br />
          Compliance Officer
          <br />
          Henkel Corporation
          <br />
          One Henkel Way
          <br />
          Rocky Hill, CT 06067
        </p>
      </li>
    </ol>
  </div>
);

export default TermsPrivacy;



// WEBPACK FOOTER //
// ./src/components/_Site/CA/TermsPrivacy.js